export const MX_TIMEZONE = 'America/Mexico_City'

const _toLocaleDateString = Date.prototype.toLocaleDateString
const _toLocaleTimeString = Date.prototype.toLocaleTimeString
const _toLocaleString = Date.prototype.toLocaleString

function withMxTz(
  options?: Intl.DateTimeFormatOptions,
): Intl.DateTimeFormatOptions {
  if (options && options.timeZone) return options
  return { ...(options ?? {}), timeZone: MX_TIMEZONE }
}

Date.prototype.toLocaleDateString = function (
  this: Date,
  locales?: Intl.LocalesArgument,
  options?: Intl.DateTimeFormatOptions,
): string {
  return _toLocaleDateString.call(this, locales, withMxTz(options))
}

Date.prototype.toLocaleTimeString = function (
  this: Date,
  locales?: Intl.LocalesArgument,
  options?: Intl.DateTimeFormatOptions,
): string {
  return _toLocaleTimeString.call(this, locales, withMxTz(options))
}

Date.prototype.toLocaleString = function (
  this: Date,
  locales?: Intl.LocalesArgument,
  options?: Intl.DateTimeFormatOptions,
): string {
  return _toLocaleString.call(this, locales, withMxTz(options))
}
